import { Form } from 'formik';
import { FormikDebounce } from '../../common/form/FormikDebounce';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { validations } from '../../../utils/validations';
import { FormContainer } from '../../common/form/FormContainer';
import { SubmitButton } from '../../common/form/SubmitButton';
import { SectionHeader } from '../../common/SectionHeader';
import { Modal as QcsModal } from '@mui/material';

import { QcsModalBox } from '../../common/basic/QcsModalBox';
import { LanguageSelect } from '../../common/form/LanguageSelect';
import { SUPPORTED_LANGUAGES } from '../../../utils/i18n';
import { codeListService } from '@api/services/services';
import { ShowError } from '../../ShowError';
import { resources } from '@api/resources';

interface Props {
  open: boolean;
  existingLanguageCodes: string[];
  reloadTrainingLangList: () => void;
  onClose: () => void;
}

interface FormValues {
  code: string;
}

export const TrainingLanguageDetailModal: FC<Props> = ({ open, existingLanguageCodes, reloadTrainingLangList, onClose }) => {
  const { t } = useTranslation();

  const handleSubmit = async (data: FormValues) => {
    const language = SUPPORTED_LANGUAGES.find((x) => x.code === data.code);
    if (!language) {
      return;
    }

    await codeListService.create(language);
    reloadTrainingLangList();
    onClose();
  };

  return (
    <QcsModal open={open} onClose={onClose}>
      <QcsModalBox>
        <SectionHeader title="admin.settings.trainingLang.adding" />
        <FormikDebounce<FormValues>
          initialValues={{ code: '' }}
          validationSchema={Yup.object().shape({
            code: validations.stringRequired(t),
          })}
          onSubmit={handleSubmit}
        >
          <Form>
            <FormContainer>
              <LanguageSelect
                name="code"
                label={t('admin.settings.trainingLang.language')}
                languages={SUPPORTED_LANGUAGES}
                notAllowedLanguages={existingLanguageCodes}
                hideNonSelected
                required
              />

              <ShowError resource={resources.createLanguage} />
              <SubmitButton text="admin.settings.trainingLang.addLanguage" />
            </FormContainer>
          </Form>
        </FormikDebounce>
      </QcsModalBox>
    </QcsModal>
  );
};
